import React from "react";
import { Modal, Pressable, View } from "react-native";
import CCText from "@/Atoms/CCText";
import ClubBadge from "./ClubBadge";
import type { PieceKey } from "../clubPieces";
import type { PromotionInfo } from "@/Hooks/ClubsApi/types";

// Celebration shown once when a club climbs a division (design lines 728–738).
export default function PromotionModal({
  promotion,
  onDismiss,
}: {
  promotion: NonNullable<PromotionInfo>;
  onDismiss: () => void;
}) {
  return (
    <Modal transparent animationType="fade" visible onRequestClose={onDismiss}>
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(38,35,34,0.55)",
          alignItems: "center",
          justifyContent: "center",
          padding: 28,
        }}
      >
        <View
          testID="promotion-modal"
          style={{
            backgroundColor: "#fff",
            borderRadius: 22,
            paddingVertical: 28,
            paddingHorizontal: 24,
            alignItems: "center",
            maxWidth: 380,
            width: "100%",
            shadowColor: "#4D3F37",
            shadowOffset: { width: 0, height: 8 },
            shadowOpacity: 0.18,
            shadowRadius: 24,
          }}
        >
          {/* New-division crest (conic-gradient tile in the design; ClubBadge here). */}
          <View
            style={{
              width: 96,
              height: 96,
              borderRadius: 26,
              backgroundColor: "#FACF47",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ClubBadge piece={promotion.to_piece as PieceKey} color="#E17B21" size={72} radius={20} />
          </View>
          <CCText
            fontWeight="thunder"
            style={{ fontSize: 26, color: "#262322", marginTop: 16, textAlign: "center" }}
          >
            {`Promoted to ${promotion.to_division} Division! 🎉`}
          </CCText>
          <CCText style={{ fontSize: 14, color: "#806234", lineHeight: 21, marginTop: 8, textAlign: "center" }}>
            {`${promotion.club_name} finished #${promotion.final_rank} in the ${promotion.from_division} Division this week. Onward and upward — new rivals await.`}
          </CCText>
          <Pressable
            testID="promotion-dismiss"
            onPress={onDismiss}
            style={{
              marginTop: 18,
              width: "100%",
              backgroundColor: "#FACF47",
              borderRadius: 32,
              paddingVertical: 14,
              alignItems: "center",
            }}
          >
            <CCText style={{ color: "#4D3F37", fontWeight: "600", fontSize: 16 }}>Let's go!</CCText>
          </Pressable>
        </View>
      </View>
    </Modal>
  );
}
